import { useTheme } from "@/src/styles/theme-provider";
import { AddCircle } from "iconsax-react-nativejs";
import React from "react";
import { Pressable, useWindowDimensions } from "react-native";
import ScButton from "./button";

type ToolbarCreateButtonProps = Readonly<{
  text: string;
  onPress: () => void;
  hideOnMobile?: boolean;
  /** Extra classes for the web button (e.g. a fixed height to match a toolbar row). */
  className?: string;
}>;

const ToolbarCreateButton = ({
  text,
  onPress,
  hideOnMobile = false,
  className,
}: ToolbarCreateButtonProps) => {
  const { width } = useWindowDimensions();
  const { themeVars } = useTheme();
  const isMobile = width < 768;

  if (isMobile) {
    if (hideOnMobile) return null;
    return (
      <Pressable
        onPress={onPress}
        hitSlop={8}
        className="active:opacity-70 rounded-full hover:bg-ash-3"
      >
        <AddCircle
          size={28}
          color={themeVars["--color-primary-default"] as string}
        />
      </Pressable>
    );
  }

  return (
    <ScButton
      text={text}
      icon={<AddCircle color="white" />}
      onPress={onPress}
      className={className}
    />
  );
};

export default ToolbarCreateButton;
